"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToChallenge = void 0;
const types_1 = require("../../../features/authoriser/types");
var PropNames;
(function (PropNames) {
    PropNames["OTP_ID"] = "otpId";
    PropNames["BIOMETRIC_ID"] = "biometricId";
    PropNames["SK_POSITIONS"] = "signatureKeyPositions";
})(PropNames || (PropNames = {}));
var IvrChallenges;
(function (IvrChallenges) {
    IvrChallenges["OTP"] = "OTP_IVR";
    IvrChallenges["SIGNATURE_KEY"] = "SIGNATURE_KEY_IVR";
})(IvrChallenges || (IvrChallenges = {}));
function isIvrFlow(challengeResponse) {
    var _a;
    return ((_a = challengeResponse.additionalParameters) === null || _a === void 0 ? void 0 : _a.channel) === 'IVR';
}
// eslint-disable-next-line complexity
const mapToChallenge = (challengeResponse) => {
    if (!(challengeResponse === null || challengeResponse === void 0 ? void 0 : challengeResponse.nextChallengeType)) {
        return {
            type: types_1.ChallengeType.NONE,
            progressId: '',
        };
    }
    const type = isIvrFlow(challengeResponse) ? IvrChallenges[challengeResponse.nextChallengeType] : challengeResponse.nextChallengeType;
    const base = {
        type,
        progressId: challengeResponse.progressId,
    };
    const validateProp = (propName) => {
        if (challengeResponse[propName]) {
            return Object.assign({ [propName]: challengeResponse[propName] }, base);
        }
        throw new Error('challengeError');
    };
    switch (type) {
        case types_1.ChallengeType.OTP:
        case types_1.ChallengeType.OTP_LOGIN:
        case types_1.ChallengeType.OTP_IVR:
            return validateProp(PropNames.OTP_ID);
        case types_1.ChallengeType.TRUSTED_CONFIRMATION:
        case types_1.ChallengeType.TRUSTED_CONFIRMATION_LOGIN:
            return validateProp(PropNames.BIOMETRIC_ID);
        case types_1.ChallengeType.SIGNATURE_KEY:
        case types_1.ChallengeType.SIGNATURE_KEY_IVR:
            return validateProp(PropNames.SK_POSITIONS);
        case types_1.ChallengeType.NONE:
            return base;
        default:
            throw new Error('challengeError');
    }
};
exports.mapToChallenge = mapToChallenge;
//# sourceMappingURL=challengeUtils.js.map